module.exports = __webpack_public_path__ + "img/subaru.c75dc974.png";